import { render, staticRenderFns } from "./IntegrationDetailsCard.vue?vue&type=template&id=10f7ac0a&scoped=true&"
import script from "./IntegrationDetailsCard.vue?vue&type=script&lang=ts&"
export * from "./IntegrationDetailsCard.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationDetailsCard.vue?vue&type=style&index=0&id=10f7ac0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f7ac0a",
  null
  
)

export default component.exports